import React from 'react'

const Prime = () => {
    return (
        <div className='container'>
            <h1> Program to Check Prime Number</h1>
            <b>Prime numbers:</b> <br />
            A prime number is a natural number greater than 1 and having no positive divisor other than 1 and itself.
<br />
For example: 3, 7, 11 etc are prime numbers. <br />
<b>Composite number:</b> <br />
Other natural numbers that are not prime numbers are called composite numbers.
<br />
For example: 4, 6, 9 etc. are composite numbers. <br />
<div className='containers'>
<ol style={{listStyle:'none'}}>
    <li ><span><span>num&nbsp;=&nbsp;int(input(</span><span class="string">"Enter&nbsp;a&nbsp;number:&nbsp;"</span><span>))&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;</span></li>
    <li ><span><span class="keywords">if</span><span>&nbsp;num&nbsp;&gt;&nbsp;</span><span class="number">1</span><span>:&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;<span class="keywords">for</span><span>&nbsp;i&nbsp;</span><span class="keywords">in</span><span>&nbsp;range(</span><span class="number">2</span><span>,num):&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>&nbsp;(num&nbsp;%&nbsp;i)&nbsp;==&nbsp;</span><span class="number">0</span><span>:&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">print</span><span>(num,</span><span class="string">"is&nbsp;not&nbsp;a&nbsp;prime&nbsp;number"</span><span>)&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">print</span><span>(i,</span><span class="string">"times"</span><span>,num//i,</span><span class="string">"is"</span><span>,num)&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">break</span><span>&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;<span class="keywords">else</span><span>:&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">print</span><span>(num,</span><span class="string">"is&nbsp;a&nbsp;prime&nbsp;number"</span><span>)&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
    <li ><span><span class="keywords">else</span><span>:&nbsp;&nbsp;</span></span></li>
    <li ><span>&nbsp;&nbsp;&nbsp;<span class="keywords">print</span><span>(num,</span><span class="string">"is&nbsp;not&nbsp;a&nbsp;prime&nbsp;number"</span><span>)&nbsp;&nbsp;</span></span></li>
    </ol></div>
        </div>
    )
}

export default Prime
